import { Button, Divider } from '@fullscreendigital/carrefour-dex-fe'
import { Box, Container, Grid } from '@mui/material'
import { TitleHeader } from 'components/shop-reception/mobile/Common/TitleHeader'
import s from './AddReportPrint.modules.scss'
import { printReturoReportPDF } from 'components/shop-reception/mobile/api'
import { useNotification } from 'hooks'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useRef } from 'react'
import { useReactToPrint } from 'react-to-print'
import { PDFPrintDocument } from 'components/core-ui/PDFPrintDocument'

const AddReportPrint = () => {
  const { showNotification } = useNotification()

  const navigate = useNavigate()

  const componentRef = useRef(null)

  const [searchParams] = useSearchParams()
  const noticeId = +searchParams.get('noticeId')

  const { data: pdfBlob, isLoading: isLoadingPdf } = printReturoReportPDF(
    showNotification,
    noticeId
  )

  const printReport = useReactToPrint({
    content: () => componentRef.current
  })

  return (
    <Container maxWidth="xs" style={{ marginTop: '20px' }}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <TitleHeader title="" />
        </Grid>
        <Grid item xs={12}>
          <Divider component="div" />
        </Grid>
        <Grid item xs={12}>
          <Box className={s.messageContainer}>A fost generat procesul verbal!</Box>
        </Grid>
        <Grid xs={12} item>
          <Button
            type="submit"
            variant="outlined"
            label="Printează"
            style={{ width: '100%' }}
            onClick={printReport}
            disabled={isLoadingPdf}
          />
        </Grid>
        <Grid xs={12} item>
          <Button
            type="submit"
            variant="contained"
            label="Am terminat"
            style={{ width: '100%' }}
            onClick={() => navigate('/returo')}
          />
        </Grid>
        <Grid xs={12} item>
          <PDFPrintDocument pdfFile={pdfBlob} componentRef={componentRef} />
        </Grid>
      </Grid>
    </Container>
  )
}

export default AddReportPrint
